module.exports = __webpack_public_path__ + "media/images/phone-ef6a74ad9291ebf26ea0017349f8211b.svg";